// eslint-disable-next-line import/prefer-default-export
export const UPDATE_COLLECTION_HISTORY = 'UPDATE_COLLECTION_HISTORY';




// WEBPACK FOOTER //
// ./src/constants/collectionHistory.js